import * as React from "react";
import { css } from "@emotion/core";
import { Alignment, Navbar, NavbarGroup } from "@blueprintjs/core";
import { FybrLogo } from "components/common";
import { useAuthState } from "context/auth";
import AuthenticatedHeader from "./AuthenticatedHeader";

const Header = () => {
  const { isAuthenticated } = useAuthState();

  return (
    <>
      <Navbar
        css={css`
          padding: 0 1rem;
          height: auto;
        `}
      >
        <NavbarGroup align={Alignment.START}>
          <FybrLogo size={33} />
        </NavbarGroup>
        {isAuthenticated && <AuthenticatedHeader />}
      </Navbar>
    </>
  );
};

export default Header;
